import { enumToOptions } from "../../common/enum/util";

export enum MadoAccountTypeEnum {
    ACTIVE = 'active',
    PASSIVE = 'passive',
    TAXABLE = 'taxable',
    NON_TAXABLE = 'nonTaxable',
}

export const madoAccountTypeOptions = enumToOptions(MadoAccountTypeEnum, 'madoAccount.accountTypeOptions.');
